import { animate, stagger } from "motion";

const easing = [0.22, 1, 0.36, 1];
const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const activeAnimations = new WeakMap();

function run(element, keyframes, options) {
  activeAnimations.get(element)?.stop();
  const controls = animate(element, keyframes, options);
  activeAnimations.set(element, controls);
  return controls;
}

function animatePageEntrance() {
  const header = document.querySelector(".glass-nav");
  if (header) animate(header, { opacity: [0, 1], y: [-10, 0] }, { duration: 0.46, ease: easing });

  const introduction = document.querySelectorAll(
    ".dashboard-welcome > *, .page-title > *, .split-title > *, .login-story > *, .login-card > *"
  );
  if (introduction.length) {
    animate(introduction, { opacity: [0, 1], y: [13, 0] }, { duration: 0.5, delay: stagger(0.04), ease: easing });
  }

  const cards = document.querySelectorAll(
    ".glass-card, .stat-tile, .metric-card, .wizard-card, .editor-card, .settings-card, .plan-page, .asset-card, .audit-card, .job-card"
  );
  if (cards.length) {
    animate(cards, { opacity: [0, 1], y: [20, 0], scale: [0.992, 1] }, { duration: 0.54, delay: stagger(0.035, { startDelay: 0.06 }), ease: easing });
  }

  const templateCards = document.querySelectorAll(".template-card");
  if (templateCards.length) {
    animate(templateCards, { opacity: [0, 1] }, { duration: 0.38, delay: stagger(0.035, { startDelay: 0.08 }), ease: easing });
    animate(
      document.querySelectorAll(".template-preview > img"),
      { opacity: [0, 1], scale: [1.09, 1] },
      { duration: 0.72, delay: stagger(0.045, { startDelay: 0.12 }), ease: easing }
    );
  }

  const statuses = document.querySelectorAll(".status, .role-badge, .eyebrow");
  if (statuses.length) {
    animate(statuses, { opacity: [0, 1], scale: [0.94, 1] }, { duration: 0.36, delay: stagger(0.02, { startDelay: 0.14 }), ease: easing });
  }

  const progressDetails = document.querySelectorAll(".health-bars i > b, .report-completion i > b");
  if (progressDetails.length) {
    animate(progressDetails, { scaleX: [0, 1] }, { duration: 0.8, delay: stagger(0.035, { startDelay: 0.18 }), ease: easing });
  }

  const ring = document.querySelector(".progress-ring");
  if (ring) animate(ring, { opacity: [0, 1], scale: [0.9, 1], rotate: [-7, 0] }, { duration: 0.7, ease: easing });
}

function addFluidInteractions() {
  const interactive = document.querySelectorAll(
    ".button, .quick-links a, .compact-job-list > a, .admin-job-table > a, .asset-library-grid article"
  );

  interactive.forEach((element) => {
    element.addEventListener("pointerenter", () => run(element, { y: -3, scale: 1.004 }, { duration: 0.2, ease: easing }));
    element.addEventListener("pointerleave", () => run(element, { y: 0, scale: 1 }, { duration: 0.26, ease: easing }));
    element.addEventListener("pointerdown", () => run(element, { scale: 0.988 }, { duration: 0.1, ease: "easeOut" }));
    element.addEventListener("pointerup", () => run(element, { scale: 1.004 }, { duration: 0.17, ease: easing }));
  });

  document.querySelectorAll("[data-filter-list]").forEach((list) => {
    list.addEventListener("listfiltered", () => {
      const visible = [...list.querySelectorAll("[data-filter-item]:not([hidden])")].slice(0, 18);
      if (visible.length) animate(visible, { opacity: [0.55, 1], x: [6, 0] }, { duration: 0.24, delay: stagger(0.012), ease: easing });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.classList.add("motion-enhanced");
  if (prefersReducedMotion.matches) return;
  animatePageEntrance();
  addFluidInteractions();
});
